/* src/app/forms/produtos/shopee/shopee-category/shopee-category.component.scss */
.content {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 80%;
  overflow: auto;
}
.content-tree {
  display: flex;
  flex-direction: column;
  height: 50vh;
  overflow: auto;
  padding: 15px;
}
.pointerMenu {
  cursor: pointer;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
}
actions-buttons {
  display: flex;
  flex-direction: column;
}
/*# sourceMappingURL=shopee-category.component.css.map */
